import React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../../../images/sendity_logo.svg';
import useIsMobile from '../../../../hooks/mobile';
import { Link } from 'react-router-dom';
import './registerStep.css';

function RegisterStep(props) {
  const { t } = useTranslation();

  const steps = props.route ? props.route : [];
  let activeStep = props.activeStep ? props.activeStep : 0;
  const isMobile = useIsMobile();
  return (
    <div className="col-md-5 step_sec_left">
      <Link to="/" className="sendity_logo">
        <img src={Logo} alt="" />
      </Link>
      {props.routeName === 'RECARGA' ? (
        <ul className="steps">
          {steps.map((step, index) => {
            let className = 'font-s';

            if (activeStep === index) {
              className = 'active font-m';
            } else if (index < activeStep) {
              className = 'completed font-s';
            }

            if (isMobile && activeStep === index) {
              return (
                <li key={index} className={className}>
                  {t(step.name)}
                  {step.step === 'FINAL_STAGE' ? '😎' : ''}
                </li>
              );
            } else if (!isMobile) {
              return (
                <li key={index} className={className}>
                  {t(step.name)}
                  {step.step === 'FINAL_STAGE' ? '😎' : ''}
                </li>
              );
            }
          })}
        </ul>
      ) : props.routeName === 'FINAL_SEND_MONEY' ? (
        <>
          {!isMobile ? (
            <ul className="final-step">
              <li className="completed font-s">{t('Destino')}</li>
              <li className="completed font-s">{t('Entrega')}</li>
              <li className="completed font-s">{t('Beneficiario')}</li>
              <li className="completed font-s">{t('Confirmar pago')}</li>
              <li className="completed font-s">😎 {t('¡Hecho!')}</li>
            </ul>
          ) : (
            <ul>
              <li className="completed font-s">😎 {t('¡Hecho!')}</li>
            </ul>
          )}
        </>
      ) : (
        <ul>
          {steps.map((step, index) => {
            let auxStep = index;
            if (activeStep < 2) {
              auxStep = 2;
              activeStep = 2;
            }
            if (activeStep === 4 && index === 4) {
              auxStep = 5;
              activeStep = 5;
            }
            let className = 'font-s';

            if (activeStep === auxStep) {
              className = 'active font-m';
            } else if (auxStep < activeStep) {
              className = 'completed font-s';
            }

            if (index < 2) return '';
            if (index === 4) return '';

            if (isMobile && activeStep === auxStep) {
              return (
                <li key={auxStep} className={className}>
                  {t(step.name)}
                  {step.step === 'FINAL_STAGE' ? '😎' : ''}
                </li>
              );
            } else if (!isMobile) {
              return (
                <li key={index} className={className}>
                  {t(step.name)}
                  {step.step === 'FINAL_STAGE' ? '😎' : ''}
                </li>
              );
            }
          })}
        </ul>
      )}
    </div>
  );
}
export default RegisterStep;
